import React from "react";
import { Route, Routes } from "react-router-dom";

import { UpdateUser, Configuration, MyProfile, WishList, Address, AddressForm, MyShopping, PaymentMethod, AddPaymentMethod } from "../View";

export const RoutesProfile = () => {
  return (
    <Routes>
      <Route path="settings" element={<Configuration />} />
      <Route path="view" element={<MyProfile />} />
      <Route path="update" element={<UpdateUser />} />
      <Route path="wishlist" element={<WishList />} />
      <Route path="address" element={<Address />} />
      <Route path="address/add" element={<AddressForm />} />
      <Route path="address/:id/update" element={<AddressForm />} />
      <Route path="my_shopping" element={<MyShopping />} />
      <Route path="my_shopping/view/:id" element={<h1> View </h1>} />
      <Route path="payment" element={<PaymentMethod />} />
      <Route path="payment/add" element={<AddPaymentMethod />} />
    </Routes>
  );
};
